import type { TenantPublic } from './contracts';

/**
 * The version suffix makes browsers fetch the Horizon mark's icons (Brendon, 2026-09-22) instead of
 * the iceberg they cached under the old `ac2` suffix. Change it whenever the icon files change.
 */
export const ICON_VERSION = 'hz1';

/** White label never substitutes the Academy's browser or installed-app artwork. */
export function brandIcons(tenant: Pick<TenantPublic, 'brand_mode' | 'logo_url'>) {
  if (tenant.brand_mode === 'whitelabel')
    return {
      favicon: tenant.logo_url,
      apple: tenant.logo_url,
      manifest: tenant.logo_url
        ? [{ src: tenant.logo_url, sizes: 'any', type: 'image/png', purpose: 'any' }]
        : [],
    };
  // The app icon keeps the mark in its central 70 percent, so the 512px file is safe to crop as a
  // maskable icon as well as to show whole. The SVG favicon switches blue with the browser theme.
  const v = `?v=${ICON_VERSION}`;
  return {
    favicon: `/icons/icon.svg${v}`,
    apple: `/icons/apple-touch-icon.png${v}`,
    manifest: [
      { src: `/icons/icon-192.png${v}`, sizes: '192x192', type: 'image/png', purpose: 'any' },
      { src: `/icons/icon-512.png${v}`, sizes: '512x512', type: 'image/png', purpose: 'any' },
      { src: `/icons/icon-512.png${v}`, sizes: '512x512', type: 'image/png', purpose: 'maskable' },
      { src: `/icons/icon.svg${v}`, sizes: 'any', type: 'image/svg+xml', purpose: 'any' },
    ],
  };
}
